import React, {
  useState,
  useLayoutEffect,
  Dispatch,
  SetStateAction
} from "react";

//styles
import styled from "styled-components";
import SV from "../../styles/variables";
import MQ from "../../styles/mediaQueries";
import "react-dates/lib/css/_datepicker.css";
import "./navbar.css";

//components
import LogoutButton from "./logoutButton";
import Select from "../../components/select/singleSelect";
import { DateRangePicker } from "custom-react-dates";
import Hamburger from "./hamburger";
//models
import { IDates } from "../../models/dates";

//helpers
import moment, { Moment } from "moment";

interface IProps {
  setStateDates: Dispatch<SetStateAction<IDates>>;
  dates: IDates;
}

const NavBarComponent: React.FunctionComponent<IProps> = ({
  setStateDates,
  dates
}) => {
  const [stores, setStateStores] = useState(mockOptions());
  const [focusedInput, setStatefocusedInput] = useState<
    "startDate" | "endDate" | null
  >(null);

  const [mobile, setStateMobile] = useState(
    window.innerWidth < mobileBreakpoint
  );

  const [mobileOpen, setStateMobileOpen] = useState(false);

  const resizeListener = () => {
    window.innerWidth < mobileBreakpoint
      ? setStateMobile(true)
      : setStateMobile(false);
  };

  useLayoutEffect(() => {
    window.addEventListener("resize", resizeListener);
    return () => window.removeEventListener("resize", resizeListener);
  }, ["USE_ONCE"]);

  const renderMenuItems = () => (
    <>
      <ul>
        <li>
          <DateRangePicker
            startDate={dates.startDate}
            startDateId="your_unique_start_date_id"
            endDate={dates.endDate}
            endDateId="your_unique_end_date_id"
            onDatesChange={({ startDate, endDate }) => {
              setStateDates({
                startDate,
                endDate
              });
            }}
            focusedInput={focusedInput}
            onFocusChange={focusedInput => setStatefocusedInput(focusedInput)}
            customArrowIcon={<To> to </To>}
            keepOpenOnDateSelect={true}
            initialVisibleMonth={() => moment().subtract(1, "months")}
            isOutsideRange={day => day.isAfter(moment(), "days")}
            daySize={28}
            verticalHeight={364}
            minimumNights={6}
            numberOfMonths={mobile ? 1 : 2}
          />
        </li>
        <li>
          <NavBarSelect options={stores} setState={setStateStores} />
        </li>
        <li>
          <LogoutButton />
        </li>
      </ul>
    </>
  );

  return (
    <>
      <Header>
        <NavBar>
          <Logo>Knights' Specs</Logo>
          <Spacer />
          {!mobile && <NavItems>{renderMenuItems()}</NavItems>}
          {mobile && (
            <Hamburger
              mobileOpen={mobileOpen}
              setStateMobileOpen={setStateMobileOpen}
            />
          )}
        </NavBar>
        {mobile && (
          <MobileNavItems className={mobileOpen ? "active" : ""}>
            {renderMenuItems()}
          </MobileNavItems>
        )}
      </Header>
      <div style={{ marginTop: `${height + 20}px` }} />
    </>
  );
};

const mockOptions = () => [
  {
    name: "All Stores",
    selected: true
  },
  {
    name: "Store 1",
    selected: false
  },
  {
    name: "Store 2",
    selected: false
  },
  {
    name: "Store 3",
    selected: false
  },
  {
    name: "Store 4",
    selected: false
  },
  {
    name: "Store 5",
    selected: false
  },
  {
    name: "Store 6",
    selected: false
  }
];

const height = 64;
const mobileBreakpoint = 820;

const To = styled.span`
  color: ${SV.colorP3};
  padding: 0 4px;
  display: block;
  line-height: 0;
  font-size: 12px;
`;

const Header = styled.header`
  position: fixed;
  display: block;
  background-color: white;
  width: 100%;
  top: 0;
  left: 0;
  height: ${height}px;

  z-index: 22;
  /* as postion fixed must provide psedo element to provide margin top" */
  ::after {
    /* position: relative;
    display: block; */
    content: "";
    margin-top: ${height};
  }
`;

const NavBar = styled.nav`
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  height: 100%;
  flex-direction: row;
`;

const Logo = styled.h1`
  color: ${SV.colorP2};
  font-size: 23.8px;
  font-weight: bold;
  padding-left: 44px;
`;

const Spacer = styled.div`
  flex: 1;
`;

const NavItems = styled.div`
  ul {
    list-style: none;
    margin: 0;
    padding: 0 10px;
    display: flex;
    li {
      padding: 0 10px;
    }
  }
`;

const MobileNavItems = styled.div`
  display: absolute;
  position: absolute;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.85);
  transition: all 0.4s ease-in-out;
  transform: translateX(-150%);
  opacity: 0;
  ul {
    list-style: none;
    align-items: center;
    flex-direction: column;
    display: flex;

    li {
      margin: 5px 0;
      display: flex;
      flex-direction: row;
    }
  }
  &.active {
    transform: translateX(0%);
    opacity: 1;
  }
`;

const NavBarSelect = styled(Select)``;

export default NavBarComponent;
